import React from 'react';
import { Link } from 'react-router-dom';
import './PageNavigation.css';

export default function PageNavigation({ shop = false }) {
    return (
        <nav className="page-navigation" aria-label="Page navigation">
            <Link to="/" className="page-navigation-link">← HOME</Link>
            {shop && <Link to="/shop" className="page-navigation-link">ALL CLOTHES →</Link>}
        </nav>
    );
}
